import './Footer.scss'


const Footer = () => {
  return (
    <footer>
      <div className="container">
        <p>© Copyrights <a target='_blank' href='https://www.emadrashad.com/'>Emad Rashad</a> 2023.</p>
      </div>
    </footer>
  )
}

export default Footer